import actionCreatorFactory from 'typescript-fsa';
import { KansatsuKirokuArchiveStatus } from '../../../models/KansatsuKirokuArchiveStatus';
// actionのprefixを設定
const actionCreator = actionCreatorFactory('fullArchiveDownloadSubdiv');

const getStatus = actionCreator.async<
  {
    koujiBangou: string;
  }, // started: parameter type
  {
    Item: KansatsuKirokuArchiveStatus;
  }, // done: success type
  {
    error: string
  } // failed: error type
  >('GET_STATUS');

const createArchive = actionCreator.async<
  {
    koujiBangou: string;
  }, // started: parameter type
  {
  }, // done: success type
  {
    error: string
  } // failed: error type
  >('CREATE_ARCHIVE');

export {
  getStatus,
  createArchive
};



// WEBPACK FOOTER //
// ./src/redux/modules/fullArchiveDownloadSubdiv/actions.ts